import Phaser from 'phaser';

export default class Player extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y, texture, frame) {
    super(scene, x, y, texture, frame);
    this.anims.play('run');
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.body.setAllowGravity = true;
    this.body.setGravityY(400);
    this.body.setSize(this.body.width * 0.15, this.body.height * 0.21);
  }

  update(controls) {
    if (
      Phaser.Input.Keyboard.JustDown(controls.jump) &&
      this.body.velocity.y === 0
    )
      this.body.velocity.y = -150;

    if (this.body.velocity.y < 0) this.anims.play('jump');
    else if (this.body.velocity.y > 0) this.anims.play('fall');
    else this.anims.play('run', true);
  }
}
